import { createAction } from '@ngrx/store';
import { TypedAction } from '@ngrx/store/src/models';

export const authLogin: (() => TypedAction<"[Auth] Login">) & TypedAction<"[Auth] Login"> = createAction('[Auth] Login');
export const authLogout: (() => TypedAction<"[Auth] Logout">) & TypedAction<"[Auth] Logout"> = createAction('[Auth] Logout');
